import React from 'react';
import { PROFILE_CARD_RARITIES, type ProfileCardRarity } from '../../types/profileCard';
import {
  PROFILE_CARD_RARITY_COLORS,
  PROFILE_CARD_RARITY_LABEL,
  PROFILE_CARD_TIER_EXCHANGE_RATE,
  PROFILE_CARD_TIER_PROBABILITY_PERCENT,
} from '../../utils/profileCardRarity';

/** 배경이 밝은 노랑(예외색)일 때 검정 텍스트 */
function rarityBadgeTextColor(rarity: ProfileCardRarity): string {
  return rarity === 'epic' ? '#1a1a1a' : '#ffffff';
}

/**
 * 프로필 카드 등급·확률·환급 규칙 안내.
 * 등급 뱃지: 배경=등급색, 텍스트=흰색(노랑 배경은 검정).
 */
const ProfileCardRarityRulesGuide: React.FC = () => (
  <div
    className="cp-pc-rarity-guide"
    data-tutorial-pin="profile-card-rarity-guide"
    aria-label="카드 등급 규칙"
  >
    <p className="cp-pc-rarity-guide-line">
      <span className="cp-pc-rarity-guide-prefix">확률/환급:</span>
      {PROFILE_CARD_RARITIES.map((r: ProfileCardRarity) => {
        const bg = PROFILE_CARD_RARITY_COLORS[r];
        const fg = rarityBadgeTextColor(r);
        return (
          <span
            key={r}
            className="cp-pc-rarity-badge"
            style={{ background: bg, color: fg, borderColor: bg }}
          >
            {PROFILE_CARD_RARITY_LABEL[r]} {PROFILE_CARD_TIER_PROBABILITY_PERCENT[r]}%·
            {Math.round(PROFILE_CARD_TIER_EXCHANGE_RATE[r] * 100)}%
          </span>
        );
      })}
    </p>
    <p className="cp-pc-rarity-guide-line">
      같은 등급은 균등 분배 · 빈 등급은 하위로 이관 ·{' '}
      <strong className="cp-pc-rarity-guide-emphasis">보통(이미지) 1장 이상 필수</strong>
    </p>
  </div>
);

export default ProfileCardRarityRulesGuide;
